import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '.';
import { IApplicationContext } from '../types/ICustomContextParams';
import { fetchGetAgentInfo, IGetAgentInfoResponse } from '../../node/repositories/agent-card/v3/get-agent-info';

export type TRealtorInfoApiEndpoints = keyof typeof realtorInfoApi.endpoints;
export let realtorInfoApi: ReturnType<typeof createRealtorInfoApi>;

export const createRealtorInfoApi = (ctx: IApplicationContext) => {
  const newApi = createApi({
    reducerPath: 'realtorInfoApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getRealtorInfo: builder.query<
        IGetAgentInfoResponse,
        {
          cianUserId: number;
        }
      >({
        query: ({ cianUserId }) => {
          return {
            parameters: {
              accountType: 'specialist',
              cianUserId,
            },
            fetchFunction: fetchGetAgentInfo,
            loggerInfo: {
              description: 'Получение информации о риелторе',
              degradation: 'Не критическая ошибка',
            },
          };
        },
      }),
    }),
  });

  realtorInfoApi = newApi;

  return newApi;
};
